import * as types from './actionTypes';

export const setCrewWithMeta = (crew, isUserAction = false) => ({
  type: types.SET_CREW,
  crew,
  meta: { isUserAction },
});

export const setEquipmentWithMeta = (equipment, isUserAction = false) => ({
  type: types.SET_EQUIPMENT,
  equipment,
  meta: { isUserAction },
});

export const setPeopleWithMeta = (people, isUserAction = false) => ({
  type: types.SET_PEOPLE,
  people,
  meta: { isUserAction },
});

export const setAttachedFilesWithMeta = (files, isUserAction = false) => ({
  type: types.SET_ATTACHED_FILES,
  files,
  meta: { isUserAction },
});
